import { render, staticRenderFns } from "./AnaliseHistorico.vue?vue&type=template&id=3b7ee07e&scoped=true&"
import script from "./AnaliseHistorico.vue?vue&type=script&lang=js&"
export * from "./AnaliseHistorico.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseHistorico.vue?vue&type=style&index=0&id=3b7ee07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ee07e",
  null
  
)

export default component.exports